import Paginate from "../../layout/Paginate";
import FilterHeader from "../../Shared/FilterHeader/FilterHeader";
import ListingCard from "../Common/ListingCard";

const MyMessages = () => {
  return (
    <div className="col-span-3 mt-[60px]">
      <FilterHeader title={"My Messages"} />
      <Paginate
        element={(props) => <ListingCard {...props} />}
        data={new Array(134).fill(0)}
        itemsPerPage={8}
        containerClassName="flex flex-col gap-10 py-10"
      />
    </div>
  );
};

export default MyMessages;
